import { detectPlatform } from '@/utils/platform';
import { createElectronServices } from './electron';
import { createCapacitorServices } from './capacitor';
import { createWebServices } from './web';
import type { PlatformServices } from './types';

export type { PlatformServices } from './types';
export type { StorageService, UpdateService, KioskService, AppService, WOLService, UpdateInfo } from './types';

let _services: PlatformServices | null = null;

export function getPlatformServices(): PlatformServices {
  if (!_services) {
    const platform = detectPlatform();
    switch (platform) {
      case 'electron':
        _services = createElectronServices();
        break;
      case 'capacitor':
        _services = createCapacitorServices();
        break;
      default:
        _services = createWebServices();
        break;
    }
  }
  return _services;
}
